import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Ag1ButtonComponent } from '../ag1-button/ag1-button.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-accordion' instead.
 */
@Component({
  selector: 'ag1-accordion',
  templateUrl: './ag1-accordion.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1ButtonComponent, AngularSvgIconModule],
})
export class Ag1AccordionComponent {
  /**
   * (Required) - the main/left label of the accordion
   */
  @Input()
  label: string;

  /**
   * (Optional) - used to specify the path of the icon, eg. '/assets/icons/general/plus.svg'
   */
  @Input()
  labelHighlightIconPath: string;

  /**
   * (Optional) - used to give a colour to the icon defined above, eg. 'red'
   */
  @Input()
  labelHighlightIconColor: string = 'french-blue';

  /**
   * (Optional) - used to conditionally show accordion sequences.
   */
  @Input()
  showSequence: boolean = false;

  /**
   * (Optional) - In cases of multiple accordions, used to sequence accordions
   */
  @Input()
  sequence: number;

  /**
   * (Optional) - used to conditionally show accordion content status,ie. is it shown or hidden
   */
  @Input()
  isVisible: boolean = false;

  /**
   * (Optional) - used to specify the variant of the accordion, eg. 'primary', 'secondary', etc.
   */
  @Input()
  variant: string = 'secondary';

  /**
   * (Optional) - used to conditionally show the 'show/hide' label
   */
  @Input()
  addShowLabel: boolean = true;

  /**
   * (Optional) - used to specify the class overrides of the accordion
   */
  @Input()
  classOverrides: string;

  /**
   * (Optional) - used to specify the right label of the accordion
   */
  @Input()
  rightLabel: string = '';

  /**
   * (Optional) - used to conditionally show the right label of the accordion
   */
  @Input()
  showRightLabel: boolean = false;

  /**
   * (Optional) - used to specify the class overrides of the accordion text
   */
  @Input()
  textClasses: string = '';

  /**
   * (Optional) - used to emit the accordion expand event, eg. when the accordion is expanded or collapsed
   */
  @Output()
  accordionExpandEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  toggleAccordion() {
    this.isVisible = !this.isVisible;
    this.accordionExpandEvent.emit(this.isVisible);
  }
}
